import { useEffect, useState } from 'react';

import { Ranking } from '../../models/Ranking';
import { RankingCard } from '../ranking-card/RankingCard';

import './CurrentRanking.light.scss';
import './CurrentRanking.dark.scss';

interface Props {
  rankings: Ranking[];
}

export function CurrentRanking({ rankings }: Props) {
  const [maxScore, setMaxScore] = useState(-Infinity);

  useEffect(() => {
    const newMaxScore = rankings.reduce((max, ranking) => Math.max(max, ranking.score), -Infinity);
    setMaxScore(newMaxScore === 0 ? -Infinity : newMaxScore);
  }, [rankings]);
  return (
    <div className='current-ranking'>
      <header>
        <h2>
          Current ranking
        </h2>
      </header>
      <ol className='current-ranking__ranking-list'>
        {
          rankings.map(ranking => (
            <RankingCard
              key={ranking.score + ranking.model.name}
              ranking={ranking}
              isBest={maxScore === ranking.score} />
          ))
        }
      </ol>
    </div>
  );
}
